
const copyToClipboard = str => {

  window.navigator.clipboard.writeText(str);

};
export default copyToClipboard
